import { CommonModule } from '@angular/common';
import { Component, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import SignaturePad from 'signature_pad';
import { MaterialModule } from '../../material.module';

@Component({
  selector: 'app-signature-pad',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  template: `
    <div class="signature-pad-container">
      <canvas #signatureCanvas></canvas>
      <button mat-raised-button class="clear-button" (click)="clear()">Clear</button>
    </div>
  `,
  styleUrls: ['./signature-pad.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: SignaturePadComponent,
    multi: true,
  }]
})
export class SignaturePadComponent implements AfterViewInit, ControlValueAccessor {
  @ViewChild('signatureCanvas') signatureCanvas: any;
  @Output() signatureChange = new EventEmitter<string>();

  signaturePad: SignaturePad | null = null;

  ngAfterViewInit() {
    this.signaturePad = new SignaturePad(this.signatureCanvas.nativeElement);

    this.signaturePad.addEventListener('endStroke', () => {
      this.propagateChange(this.signaturePad!.toDataURL());
    });
  }

  clear() {
    if (this.signaturePad) {
      this.signaturePad.clear();
      this.propagateChange('');
    }
  }

  writeValue(value: any): void {
    if (this.signaturePad) {
      if (value) {
        this.signaturePad.fromDataURL(value);
      } else {
        this.signaturePad.clear();
      }
    }
  }

  propagateChange = (_: any) => {};

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}
}
